import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HippaCompliance } from 'src/app/Models/hippacompliance.model';
import { HippaComplianceService } from 'src/app/services/hippa-compliance.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-view-hippa-compliance',
  templateUrl: './view-hippa-compliance.component.html',
  styleUrls: ['./view-hippa-compliance.component.css'],
})
export class ViewHippaComplianceComponent implements OnInit {
  id = 0;
  hippaComplianceList: HippaCompliance[] = [];
  constructor(
    private route: ActivatedRoute,
    private patientService: PatientService,
    private hippaComplianceService: HippaComplianceService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });

    this.getHippaCompliance(this.id);
  }

  getHippaCompliance(id) {
    this.patientService.getHippaCompliance(id).subscribe((res) => {
      this.hippaComplianceList = res.HippaCompliances;
    });
  }

  print() {
    window.print();
  }

  delete(id) {
    this.hippaComplianceService.deleteHippaCompliance(id).subscribe((res) => {
      this.getHippaCompliance(this.id);
    });
  }
}
